<template>
  <b-card class="cardStyle enrollment-inside-card-height">
    <p class="m-0 card-title pb-5">
      <b-icon icon="flag-fill" scale="1.2"></b-icon>&nbsp; Country statistics:
      <strong>{{ siteCountryDetails['country'] }}</strong>
    </p>
    <b-row class="m-0" style="height:54%;width:100%;">
      <b-col class="p-0 p-4 text-center" cols="12" lg="7" md="7" sm="7" xl="7">
        <country-image :country="siteCountryDetails['country']"></country-image>
      </b-col>
      <b-col class="p-0" cols="12" lg="5" md="5" sm="5" xl="5">
        <b-row class="mt-3 text-right">
          <b-col cols="6" lg="6" md="6" sm="6" xl="6">
            <p class="m-0 mt-1 info-text-style">Screened</p>
            <p class="text-primaryLight info-number-style">
              {{ siteCountryDetails['enrollmentData']['screened'] }}
            </p>
          </b-col>
          <b-col cols="6" lg="6" md="6" sm="6" xl="6">
            <p class="m-0 mt-1 info-text-style">Ongoing</p>
            <p class="text-warning info-number-style">
              {{ ongoing }}
            </p>
          </b-col>
          <b-col cols="6" lg="6" md="6" sm="6" xl="6">
            <p class="m-0 mt-3 info-text-style">Screen Failed</p>
            <p class="text-danger info-number-style">
              {{ siteCountryDetails['enrollmentData']['screenFailed'] }}
            </p>
          </b-col>
          <b-col cols="6" lg="6" md="6" sm="6" xl="6">
            <p class="m-0 mt-3 info-text-style">Completed</p>
            <p class="text-success info-number-style">
              {{ siteCountryDetails['enrollmentData']['completed'] }}
            </p>
          </b-col>
          <b-col cols="6" lg="6" md="6" sm="6" xl="6">
            <p class="mb-0 mt-3 info-text-style">Average Screen Fail Rate</p>
            <p class="number-fail-rate mt-2">{{ averageScreenFailRate }}%</p>
          </b-col>
          <!-- <b-col cols="6" lg="6" md="6" sm="6" xl="6">
            <p class="m-0 mt-3 info-text-style">Discontinued</p>
            <p class="info-number-style" style="color:#6F6F6F">
              {{ siteCountryDetails['enrollmentData']['discontinued'] }}
            </p>
          </b-col> -->
        </b-row>
      </b-col>
    </b-row>
    <b-row align-h="end" class="m-0 mt-2">
      <b-col
        class="border-radius-left-sm px-0"
        cols="12"
        lg="3"
        md="3"
        sm="6"
        style="background:rgba(191, 191, 241, 0.12);"
        xl="3"
      >
        <p class="my-3 info-text-style">
          <strong>Sites</strong>
        </p>
      </b-col>
      <b-col
        class="goal-randomized-text pr-0 border-radius-right-sm"
        cols="12"
        lg="3"
        md="3"
        sm="6"
        style="background:rgba(191, 191, 241, 0.12);"
        xl="4"
        ><p class="my-3 map-card-number" style="line-height:14px;">
          {{ siteCountryDetails['siteCount'] }}
        </p></b-col
      >
    </b-row>
    <b-row align-h="end" class="m-0 mt-2">
      <b-col
        class="border-radius-left-sm px-0"
        cols="12"
        lg="3"
        md="3"
        sm="6"
        style="background:rgba(191, 191, 241, 0.12);"
        xl="3"
      >
        <p class="my-3 info-text-style">
          <strong>Total Planned</strong>
        </p>
      </b-col>
      <b-col
        class="goal-randomized-text pr-0 border-radius-right-sm"
        cols="12"
        lg="3"
        md="3"
        sm="6"
        style="background:rgba(191, 191, 241, 0.12);"
        xl="4"
        ><p class="my-3 map-card-number" :style="plannedStyle">
          {{ planned }}
        </p></b-col
      >
    </b-row>
    <b-row align-h="end" class="m-0 mt-2" style="height:12%;width:100%;">
      <b-col
        class="border-radius-left-sm px-0"
        cols="12"
        lg="3"
        md="3"
        sm="6"
        style="background:rgba(191, 191, 241, 0.12);"
        xl="3"
      >
        <p class="m-0 mt-3 info-text-style">
          <strong>Total Randomized</strong>
        </p>
        <p class="m-1 mb-3 info-text-style">
          {{ randomizedSubText }}
        </p>
      </b-col>
      <b-col
        class="goal-randomized-text pr-0 border-radius-right-sm"
        cols="12"
        lg="3"
        md="3"
        sm="6"
        style="background:rgba(191, 191, 241, 0.12);"
        xl="4"
        ><p class="custom-margin">
          <span style="color:#01004E">
            {{ siteCountryDetails['enrollmentData']['randomized'] }}</span
          ><span v-if="targetPercentage !== '-'" style="color:#6F6F6F">/{{ countryGoal }}</span>
          <span v-if="targetPercentage !== '-'" style="font-size: 22px;color:#6F6F6F;">
            ({{ targetPercentage }}%)</span
          >
        </p></b-col
      >
    </b-row>
  </b-card>
</template>

<script>
  import CountryImage from './CountryImage';

  export default {
    components: {
      CountryImage,
    },
    props: {
      siteCountryDetails: Object,
      countryGoal: { type: [Number, String] },
    },
    data() {
      return {
        targetPercentage: 0,
      };
    },
    computed: {
      planned() {
        return this.siteCountryDetails['plannedSubjects'] ?? 'N/A';
      },
      plannedStyle() {
        return this.planned === 'N/A' ? 'line-height:11px;font-size:18px' : 'line-height:14px;';
      },
      ongoing() {
        return (
          this.siteCountryDetails['enrollmentData']['randomized'] -
          this.siteCountryDetails['enrollmentData']['discontinued'] -
          this.siteCountryDetails['enrollmentData']['completed']
        );
      },
      randomizedSubText() {
        return this.targetPercentage !== '-' ? '(Current/Target)' : '(Current)';
      },
      averageScreenFailRate() {
        let avg = 0;
        if (
          this.siteCountryDetails['enrollmentData']['screenFailed'] &&
          this.siteCountryDetails['enrollmentData']['screened']
        ) {
          avg = (
            (this.siteCountryDetails['enrollmentData']['screenFailed'] /
              this.siteCountryDetails['enrollmentData']['screened']) *
            100
          ).toFixed(1);
        }
        return avg;
      },
    },
    created() {
      if (typeof this.countryGoal === 'number' && this.countryGoal !== 0) {
        this.targetPercentage = (
          (this.siteCountryDetails['enrollmentData']['randomized'] / this.countryGoal) *
          100
        ).toFixed(0);
      } else {
        this.targetPercentage = '-';
      }
    },
  };
</script>

<style scoped>
  .info-number-style {
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
    margin: 0px;
    margin-top: 0.75rem;
  }

  .number-fail-rate {
    font-weight: 700;
    font-size: 18px;
    line-height: 18px;
    color: #6f6f6f;
  }
</style>
